import { Deposit, DepositPaymentStatus } from 'entities/Deposit/model/types';
import { getLastItem } from 'shared/utils/helpers/array';

export const getDepositStatus = (deposit: Deposit): DepositPaymentStatus => {
  const latestHistory = getLastItem(deposit.depositHistory);

  const isRefunded = latestHistory ? latestHistory.isRefunded : false;
  const refundedDepositAmount = latestHistory ? latestHistory.refundedDepositAmount : 0;
  const cancelledDepositAmount = latestHistory ? latestHistory.cancelledDepositAmount : 0;
  const depositAmount = latestHistory ? latestHistory.depositAmount : 0;
  const initialDepositAmount = deposit.initialDepositAmount;

  if (isRefunded) {
    return DepositPaymentStatus.REFUNDED;
  }
  if (refundedDepositAmount > 0 && !isRefunded) {
    return DepositPaymentStatus.PARTIAL_REFUND;
  }
  if (cancelledDepositAmount > 0) {
    return DepositPaymentStatus.CANCELLED;
  }
  if (depositAmount === initialDepositAmount) {
    return DepositPaymentStatus.PAID;
  }
  if (depositAmount > 0) {
    return DepositPaymentStatus.PARTIAL_PAYMENT;
  }
  return DepositPaymentStatus.NOT_PAID;
};

export const getCurrentDepositStatus = (deposit: Deposit): DepositPaymentStatus => {
  if (deposit.isRefunded) {
    return DepositPaymentStatus.REFUNDED;
  }
  if (deposit.refundedDepositAmount > 0 && !deposit.isRefunded) {
    return DepositPaymentStatus.PARTIAL_REFUND;
  }
  if (deposit.cancelledDepositAmount > 0) {
    return DepositPaymentStatus.CANCELLED;
  }
  if (deposit.depositAmount === deposit.initialDepositAmount) {
    return DepositPaymentStatus.PAID;
  }
  if (deposit.depositAmount > 0) {
    return DepositPaymentStatus.PARTIAL_PAYMENT;
  }
  return DepositPaymentStatus.NOT_PAID;
};
